export default {
  data() {
    return {
      intersection: {
        observer: null,
        isVisible: false,
        ratio: null
      },
      resize: {
        observer: null,
        size: null,
        breakpoints: null
      },
      screen: {
        size: null,
        isTouch: false,
        queries: null
      }
    };
  },
  methods: {
    screen_checkTouch() {
      try {
        document.createEvent("TouchEvent");
        this.screen.isTouch = true;
      } catch {
        this.screen.isTouch = false;
      }
    },
    screen_checkSize() {
      this.screen.size = this.screen.queries.find(query => query[1].matches)[0];
    },
    screen_init() {
      const doc = getComputedStyle(document.documentElement);
      const queries = [
        ["XL", window.matchMedia(`(min-width: ${parseInt(doc.getPropertyValue("--xl"))}px)`)],
        ["LG", window.matchMedia(`(min-width: ${parseInt(doc.getPropertyValue("--lg"))}px)`)],
        ["MD", window.matchMedia(`(min-width: ${parseInt(doc.getPropertyValue("--md"))}px)`)],
        ["SM", window.matchMedia(`(min-width: ${parseInt(doc.getPropertyValue("--sm"))}px)`)],
        ["XS", window.matchMedia(`(min-width: ${parseInt(doc.getPropertyValue("--xs"))}px)`)]
      ];

      this.screen.queries = queries
      this.screen_checkTouch();
      this.screen_checkSize();
      this.screen.queries.forEach(query => query[1].addListener(this.screen_checkSize));
    },
    intersection_onChange(entries) {
      entries.forEach(entry => {
        this.intersection.isVisible = entry.isIntersecting;
        this.intersection.ratio = (Math.round(entry.intersectionRatio * 4) / 4).toFixed(2);
      });
    },
    intersection_createObserver() {
      this.intersection.observer = new IntersectionObserver(this.intersection_onChange, {
        threshold: [0, 0.25, 0.5, 0.75, 1]
      });
    },
    intersection_unobserve() {
      if (this.intersection.observer) {
        this.intersection.observer.unobserve(this.$el)
      }
    },
    intersection_init() {
      this.intersection_createObserver();
      this.intersection.observer.observe(this.$el);
    },
    resize_onChange(entries) {
      entries.forEach(entry => {
        this.resize.breakpoints.some(bp => {
          if (entry.contentRect.width >= bp[1]) {
            if (this.resize.size !== bp[0]) {
              this.resize.size = bp[0];
            }
            return true;
          }
          return false;
        });
      });
    },
    resize_createObserver() {
      this.resize.observer = new ResizeObserver(this.resize_onChange);
    },
    resize_unobserve() {
      if (this.resize.observer) {
        this.resize.observer.unobserve(this.$el)
      }
    },
    resize_init() {
      const doc = getComputedStyle(document.documentElement);
      const breakpoints = [
        ["XL", parseInt(doc.getPropertyValue("--xl"))],
        ["LG", parseInt(doc.getPropertyValue("--lg"))],
        ["MD", parseInt(doc.getPropertyValue("--md"))],
        ["SM", parseInt(doc.getPropertyValue("--sm"))],
        ["XS", parseInt(doc.getPropertyValue("--xs"))]
      ];
      breakpoints.sort((a, b) => (a[1] > b[1] ? -1 : a[1] < b[1] ? 1 : 0));
      this.resize.breakpoints = breakpoints;
      this.resize_createObserver();
      this.resize.observer.observe(this.$el);
    }
  },
  beforeDestroy() {
    this.intersection_unobserve();
    this.resize_unobserve();
  }
};
